import React, { useState, useContext } from "react";
import { ThemeContext } from "../../contexts/ThemeContext";
import { LanguageContext } from "../../contexts/LanguageContext";
import logoBranca from "../../images/Integrarq_Logo branca sem fundo.png";
import { FaGlobe } from "react-icons/fa";
import { useEffect } from "react";

import {
  StyledHeader,
  Logo,
  Nav,
  Menu,
  MenuItem,
  MobileMenuIcon,
  SiteControls,
  ThemeToggle,
  LanguageSelector,
  LanguageButton,
  LanguageDropdown,
} from "./styles";

const Header = () => {
  const [activeSection, setActiveSection] = useState("inicio");
  const { theme, toggleTheme } = useContext(ThemeContext);
  const { language, changeLanguage, translations } =
    useContext(LanguageContext);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [languageDropdownOpen, setLanguageDropdownOpen] = useState(false);

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  const handleMenuClick = (anchor) => {
    setMobileMenuOpen(false); // fecha o menu ao clicar
    const target = document.getElementById(anchor);
    if (target) {
      const offset = document.querySelector("header")?.offsetHeight || 100;

      const top = target.getBoundingClientRect().top + window.scrollY - offset;
      window.scrollTo({ top, behavior: "smooth" });
    }
  };

  const toggleLanguageDropdown = () => {
    setLanguageDropdownOpen(!languageDropdownOpen);
  };

  const handleLanguageChange = (lang) => {
    changeLanguage(lang);
    setLanguageDropdownOpen(false);
  };

useEffect(() => {
  const handleScroll = () => {
    const sections = [
      "contato",
      "clientes",
      "sobre",
      "diferenciais",
      "servicos",
      "problema",
      "inicio"
    ];

    const headerOffset = document.querySelector("header")?.offsetHeight || 100;
    const scrollY = window.scrollY + headerOffset + 10; 

    let current = activeSection;

    for (let i = 0; i < sections.length; i++) {
      const section = document.getElementById(sections[i]);
      if (section) {
        const top = section.offsetTop;
        const bottom = top + section.offsetHeight;

        if (scrollY >= top && scrollY < bottom) {
          current = sections[i];
          break;
        }
      }
    }

    if (current !== activeSection) setActiveSection(current);
  };

  window.addEventListener("scroll", handleScroll);
  handleScroll(); // inicializa corretamente

  return () => window.removeEventListener("scroll", handleScroll);
}, [activeSection]);

return (
  <StyledHeader>
    <div className="container">
      <Logo>
        <a href="#inicio">
          <img src={logoBranca} alt="Integrarq" />
        </a>
      </Logo>

      <Nav>
        <Menu className={mobileMenuOpen ? "active" : ""}>
          <MenuItem>
            <a
              className={activeSection === "inicio" ? "active" : ""}
              onClick={() => handleMenuClick("inicio")}
            >
              {translations[language].home}
            </a>
          </MenuItem>
          <MenuItem>
            <a
              className={activeSection === "problema" ? "active" : ""}
              onClick={() => handleMenuClick("problema")}
            >
              {translations[language].problem}
            </a>
          </MenuItem>
          <MenuItem>
            <a
              className={activeSection === "servicos" ? "active" : ""}
              onClick={() => handleMenuClick("servicos")}
            >
              {translations[language].services}
            </a>
          </MenuItem>
          <MenuItem>
            <a
              className={activeSection === "diferenciais" ? "active" : ""}
              onClick={() => handleMenuClick("diferenciais")}
            >
              {translations[language].differentials}
            </a>
          </MenuItem>
          <MenuItem>
            <a
              className={activeSection === "sobre" ? "active" : ""}
              onClick={() => handleMenuClick("sobre")}
            >
              {translations[language].about}
            </a>
          </MenuItem>
          <MenuItem>
            <a
              className={activeSection === "clientes" ? "active" : ""}
              onClick={() => handleMenuClick("clientes")}
            >
              {translations[language].clients}
            </a>
          </MenuItem>
          <MenuItem>
            <a
              className={activeSection === "contato" ? "active" : ""}
              onClick={() => handleMenuClick("contato")}
            >
              {translations[language].contact}
            </a>
          </MenuItem>
        </Menu>

        <MobileMenuIcon
          onClick={toggleMobileMenu}
          className={mobileMenuOpen ? "open" : ""}
        >
          <span></span>
          <span></span>
          <span></span>
        </MobileMenuIcon>
      </Nav>

      <SiteControls>
        <ThemeToggle
          onClick={toggleTheme}
          theme={theme}
          title="Alternar tema claro/escuro"
        >
          <span className="icon icon-moon">
            <i className="fas fa-moon"></i>
          </span>
          <span className="icon icon-sun">
            <i className="fas fa-sun"></i>
          </span>
        </ThemeToggle>

        <LanguageSelector>
          <LanguageButton
            onClick={toggleLanguageDropdown}
            aria-label={translations[language].language}
          >
            <i className="fas fa-globe language-icon"></i>
            <span>{translations[language].language}</span>
          </LanguageButton>
          <LanguageDropdown className={languageDropdownOpen ? "active" : ""}>
            <a href="#" onClick={() => handleLanguageChange("pt")}>
              {translations[language].portuguese}
            </a>
            <a href="#" onClick={() => handleLanguageChange("en")}>
              {translations[language].english}
            </a>
            <a href="#" onClick={() => handleLanguageChange("es")}>
              {translations[language].spanish}
            </a>
            <a href="#" onClick={() => handleLanguageChange("it")}>
              {translations[language].italian}
            </a>
          </LanguageDropdown>
        </LanguageSelector>
      </SiteControls>
    </div>
  </StyledHeader>
);

};

export default Header;
